import { Col } from '../../col';
import { Row } from '../../row';
import { ShareItem, type ShareItemProperties } from '../share-item';

export type ShareItemsProperties = {
  items: ShareItemProperties[];
  itemsPerRow?: number;
};

const ShareItems = ({ items, itemsPerRow = items.length }: ShareItemsProperties) => {
  const rows: ShareItemProperties[][] = [];

  for (let index = 0; index < items.length; index += itemsPerRow) {
    rows.push(items.slice(index, index + itemsPerRow));
  }

  return (
    <>
      {rows.map((rowItems, rowIndex) => (
        // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        <Row key={`share-item-${rowIndex}`}>
          {rowItems.map(({ key, ...shareItem }) => (
            <Col flex="1" key={key}>
              <ShareItem {...shareItem} />
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
};

export default ShareItems;
